import type * as THREE from 'three';
import type { BirdsBlock } from '@vrlearning/lesson-schema';
import { buildGulls } from '../gulls.js';
import type { WorldBuilder } from '../world.js';

/** The birds block (W2; from gulls.ts): one instanced mesh in the air, gliding its flights. */
export function buildBirdsBlock(
  world: WorldBuilder,
  block: BirdsBlock,
  name: string,
): THREE.InstancedMesh {
  const birds = buildGulls(world.wind, {
    flights: block.flights,
    size: block.size,
    colour: block.colour,
    emissive: block.emissive,
    name,
  });
  world.addAir(birds.mesh);
  world.onFrame((_dt, elapsed) => birds.update(elapsed));
  return birds.mesh;
}
